"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityViewedByNursePropertiesDto = instanceOfOrientationOpportunityViewedByNursePropertiesDto;
exports.OrientationOpportunityViewedByNursePropertiesDtoFromJSON = OrientationOpportunityViewedByNursePropertiesDtoFromJSON;
exports.OrientationOpportunityViewedByNursePropertiesDtoFromJSONTyped = OrientationOpportunityViewedByNursePropertiesDtoFromJSONTyped;
exports.OrientationOpportunityViewedByNursePropertiesDtoToJSON = OrientationOpportunityViewedByNursePropertiesDtoToJSON;
exports.OrientationOpportunityViewedByNursePropertiesDtoToJSONTyped = OrientationOpportunityViewedByNursePropertiesDtoToJSONTyped;
const OrientationOpportunityViewedByNurseSource_1 = require("./OrientationOpportunityViewedByNurseSource");
/**
 * Check if a given object implements the OrientationOpportunityViewedByNursePropertiesDto interface.
 */
function instanceOfOrientationOpportunityViewedByNursePropertiesDto(value) {
    if (!('orientationOpportunityId' in value) || value['orientationOpportunityId'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityViewedByNursePropertiesDtoFromJSON(json) {
    return OrientationOpportunityViewedByNursePropertiesDtoFromJSONTyped(json, false);
}
function OrientationOpportunityViewedByNursePropertiesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orientationOpportunityId': json['orientationOpportunityId'],
        'source': (0, OrientationOpportunityViewedByNurseSource_1.OrientationOpportunityViewedByNurseSourceFromJSON)(json['source']),
    };
}
function OrientationOpportunityViewedByNursePropertiesDtoToJSON(json) {
    return OrientationOpportunityViewedByNursePropertiesDtoToJSONTyped(json, false);
}
function OrientationOpportunityViewedByNursePropertiesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orientationOpportunityId': value['orientationOpportunityId'],
        'source': (0, OrientationOpportunityViewedByNurseSource_1.OrientationOpportunityViewedByNurseSourceToJSON)(value['source']),
    };
}
//# sourceMappingURL=OrientationOpportunityViewedByNursePropertiesDto.js.map